export default __webpack_public_path__ + "static/media/android.86fe336e.png";